import React from "react";

function ExclamationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="37"
      viewBox="0 0 6 37"
      fill="none"
    >
      <g clip-path="url(#clip0_2791_3671)">
        <path
          d="M5.25 5C5.25 3.75547 4.24453 2.75 3 2.75C1.75547 2.75 0.75 3.75547 0.75 5V23C0.75 24.2445 1.75547 25.25 3 25.25C4.24453 25.25 5.25 24.2445 5.25 23V5ZM3 34.25C3.74592 34.25 4.46129 33.9537 4.98874 33.4262C5.51618 32.8988 5.8125 32.1834 5.8125 31.4375C5.8125 30.6916 5.51618 29.9762 4.98874 29.4488C4.46129 28.9213 3.74592 28.625 3 28.625C2.25408 28.625 1.53871 28.9213 1.01126 29.4488C0.483816 29.9762 0.1875 30.6916 0.1875 31.4375C0.1875 32.1834 0.483816 32.8988 1.01126 33.4262C1.53871 33.9537 2.25408 34.25 3 34.25Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2791_3671">
          <path d="M0.75 0.5H5.25V36.5H0.75V0.5Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ExclamationIcon;
